<script setup>
import { ref } from "vue";

const menuGroup = ref(null);

const currentDisclosure = ref(null);

function setCurrentDisclosure(disclosure) {
  currentDisclosure.value = disclosure;

  const currentDisclosureButton = currentDisclosure.value.$el.querySelector(
    ".menu-disclosure-button",
  );

  menuGroup.value.querySelectorAll(".menu-disclosure-button").forEach((el) => {
    let alwaysOpen = el.parentNode.classList.contains("always-open");

    if (
      el !== currentDisclosureButton &&
      el.getAttribute("aria-expanded") === "true" &&
      !alwaysOpen
    ) {
      el.click();
    }
  });
}
</script>

<template>
  <div ref="menuGroup" class="flex flex-col gap-2">
    <slot
      :currentDisclosure="currentDisclosure"
      :setCurrentDisclosure="setCurrentDisclosure"
    />
  </div>
</template>
